import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import Utility from "../../../shared/utility";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import draggable from "vuedraggable";
import BackToTop from "../../common/back-to-top.vue";
export default {
  data: () => ({
    name: "ServiceLevels",
    backSlash: true,
    refresh: true,
    mainPage: "",
    subPage: "",
    back: true,
    subPageUrl: "",
    pageUrl: "",
    appPageName: "",
    backSlashParent: true,
    favouriteList: [],
    showAdd: false,
    userId: EncryptUtility.localStorageDecrypt("userID"),
    selectedType: "O",
    rankServiceLevelHeaders: [
      {
        text: "",
        align: "start",
        value: "Handle",
        sortable: false,
        class: "primary customwhite--text",
      },
      {
        text: "Rank",
        value: "sequence",
        class: "primary customwhite--text",
      },
      {
        text: "Service Level",
        value: "Service_Level",
        class: "primary customwhite--text",
      },
      {
        text: "Domestic",
        value: "Domestic",
        class: "primary customwhite--text",
      },
      {
        text: "Active",
        value: "Active",
        class: "primary customwhite--text",
      },
    ],
    typeList: [
      {
        text: "Outbound",
        value: "O",
      },
      {
        text: "Inbound",
        value: "I",
      },
    ],
    rankServiceLevelList: [],
    totalRecords: 0,
    actionList: [],
    serviceLevelsData: [],
    selectedProject: "",
    selectedBusiness: "",
    selectedOrderType: "",
    submitRankList: [],
  }),
  async created() {
    let dataSimple = await AddFavourite.getPageAction(this.userId, "app-service-level");
    this.route = this.$route.path.replace("/", "").split("/")[0];
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    this.actionList = dataSimple.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.subPageUrl = data.subPageUrl;
    this.appPageName = data.appPageName;
  },
  mounted() {
    this.serviceLevelsData = JSON.parse(atob(this.$route.params.serviceLevelsRank));
    this.selectedProject = this.serviceLevelsData.project;
    this.selectedBusiness = this.serviceLevelsData.business;
    this.selectedOrderType = this.serviceLevelsData.ordertype;
    this.changeType();
  },
  methods: {
    //Getting data based on the order type selected
    changeType() {
      this.rankServiceLevelList = [];
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let serviceLevelObj = {
        bu_id: this.serviceLevelsData.bu_id,
        UserId: parseInt(this.userId),
        sbu_id: parseInt(this.serviceLevelsData.sbu_id),
        ord_code: this.serviceLevelsData.ord_code,
        type: this.selectedType,
      };
      this.totalRecords = 0;
      this.axios
        .post("/cp/servicelevels_ranklist", serviceLevelObj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let responseData = JSON.parse(response.data.body.message);
            this.rankServiceLevelList = responseData;
            if (responseData.length == 0) {
              this.totalRecords = 0;
            } else {
              this.totalRecords = responseData.length;
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    // to set the action
    actionSetter(action) {
      if (this.actionList !== null && this.actionList.length > 0) {
        let filter = this.actionList.filter((entry) => entry.SystemName === action);
        return filter !== undefined && filter !== null && filter.length == 1 ? true : false;
      } else return false;
    },
    //  on Click of Favorite icon
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
    //On Drag
    onDragEnd() {
      this.rankServiceLevelList?.forEach((item, index) => {
        item.sequence = index + 1;
      });
    },
    //Submit the ranked service levels
    submitRankServiceLevel() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.submitRankList = [];
      this.rankServiceLevelList.forEach((item) => {
        let rankObj = {
          sequence: item.sequence,
          slbu_id: item.slbu_id,
        };
        this.submitRankList.push(rankObj);
      });
      let newServicelevelObj = {
        InJson: JSON.stringify({
          User_id: parseInt(this.userId),
          proj_key: this.serviceLevelsData.projKey,
          bu_key: this.serviceLevelsData.bu_id,
          ord_code: this.serviceLevelsData.ord_code,
          type: this.selectedType,
          servicelevel: this.submitRankList,
        }),
      };
      this.axios
        .post("/cp/servicelevels_rank_upsert", newServicelevelObj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.submitRankList = [];
            this.changeType();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
  },
  components: {
    breadcrumbComp,
    draggable,
    BackToTop,
  },
};
